import { Modal } from '@mantine/core'
import EmailLogin from './EmailLogin'

export default function EmailLoginModal({ opened, onClose, roomId, ...props }) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Log In"
      centered
      {...props}
    >
      <EmailLogin
        onClose={onClose}
        roomId={roomId}
      />
    </Modal>
  )
}

